import React, { useEffect } from 'react'
import { Spin } from 'antd'
import * as utils from '../../utils'
import "../../index.css"

import { useHistory } from 'react-router-dom'

export default function Home() {
  const history = useHistory()
  useEffect(() => {
    console.log("inside the use effect hook of events page")
    utils.getSession().then(session => {
      history.push("/events")
    }).catch(err => {
      console.error('Error in fetching session :: ', err)
      history.push("/login")
    })
  }, [history])
  return (
    <div className='align-center'>
      <h2>Live Portal Home</h2>
      <Spin/>
    </div>
  )
};